import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankingCredentialsService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getBankProvider(): Promise<any> {
    return firstValueFrom(this.http.get<any>(this.url('/bankProvider')));
  }

  updateBankProvider(payload: any): Observable<any> {
    return this.http.put<any>(this.url('/bankProvider'), payload);
  }
}